import axios from "axios";
import { restAPI, redirectUri } from "../pages/login/common/OAuth.js";
import { getCookie } from "./cookie";

// 배포
axios.defaults.baseURL = "https://node.floway.co.kr";

// const config = {
//     headers: {
//         'token': getToken(),
//         // 'token': null,
//     }
// }

// const accessToken = getToken()

export const userAPI = {
  kakaoLogin: async function (code) {
    const grant_type = "authorization_code";
    const client_id = restAPI;
    const _headers = {
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    };
    const _body = `https://kauth.kakao.com/oauth/token?grant_type=${grant_type}&client_id=${client_id}&redirect_uri=${redirectUri}&code=${code}`;
    const res = await axios.get(_body, { headers: _headers });
    console.log(res);
    return res;
  },

  kakaoLogout: async function (data) {
    const _url = "https://kapi.kakao.com/v1/user/logout";
    const _headers = {
      "Content-type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${data.kakaoAccessToken}`,
    };
    const _body = {
      target_id_type: "user_id",
      target_id: data.userId,
    };
    console.log(_headers);
    const res = await axios.post(_url, _body, { headers: _headers });
    console.log(res);
    // 카카오 로그아웃 + 토큰 만료
  },

  kakaoUnlink: async function (data) {
    const _url = "https://kapi.kakao.com/v1/user/unlink";
    const _headers = {
      "Content-type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${data.kakaoAccessToken}`,
    };
    const _body = {
      target_id_type: "user_id",
      target_id: data.userId,
    };
    console.log(_headers);
    const res = await axios.post(_url, _body, { headers: _headers });
    console.log(res);
    return res;
    // 카카오 로그아웃 + 토큰 만료
  },

  UncertiSignup: async function (type, token) {
    const body = {
      type: type,
      token: token,
    };
    console.log(body);
    const res = await axios.post("/users/reg-normal", body);
    console.log(res);
    return res;
  },

  GetUserInfosKakao: async function (kakaoToken) {
    console.log(kakaoToken);
    const res = await axios.post("/users/login", kakaoToken);
    console.log(res);
    return res;
  },

  GetUserInfos: async function (token) {
    console.log({ headers: token });
    const res = await axios.get("/users", { headers: token });
    console.log(res);

    return res;
  },

  PostCertiFile: async function (formData) {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        // 'Access-Control-Allow-Origin': 'multipart/form-data'
      },
    };
    // const body = { regImage: formData }
    const res = await axios.post("/users/reg-image", formData, config);
    console.log(res);
    return res;
  },

  UpdateCertiFile: async function (formData, token) {
    console.log(token);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    const res = await axios.put("/users/reg-image", formData, config);
    return res;
  },

  UpdateProfile: async function (formdata, token) {
    console.log({ headers: token });
    const res = await axios.put("/users", formdata, { headers: token });
    console.log(res);

    return res;
  },
};
